import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Onethreeseatertempolavasa() {



const cardData =
{
  keyword: '13 Seater Tempo Traveller for Lavasa Tour',
  heading: 'Sanavi Travels: 13 Seater Tempo Traveller for Lavasa Tour',
  headingDescription: 'Sanavi Travels offers premium and highly reliable 13 Seater Tempo Traveller for Lavasa Tour, specially designed for families, friend groups, corporate teams, picnic planners, wedding guests, and leisure travelers looking for a comfortable and scenic journey to Lavasa. Lavasa, known for its beautiful lake views, winding ghat roads, pleasant weather, and European-style township, is a popular short-trip destination from Pune.',

  top: 'Popular Travel Experiences with 13 Seater Tempo Traveller for Lavasa Tour',

  "topPlaces": [
    {
      "title": "Scenic Pune to Lavasa Drive",
      "description": "The drive from Pune to Lavasa is filled with lush greenery, winding ghat roads, and panoramic valley views. Traveling in a 13 seater Tempo Traveller allows your group to relax, enjoy the scenery together, and avoid the fatigue of driving on hilly roads, especially during monsoon and weekend rush."
    },
    {
      "title": "Lavasa Waterfront & Promenade",
      "description": "Lavasa’s waterfront area is the heart of the township, offering beautiful lake views, cafes, and walking paths. Group travel in a Tempo Traveller ensures convenient drop-offs, easy coordination, and comfortable return journeys after leisure walks and dining."
    },
    {
      "title": "Family Picnic & Group Outings",
      "description": "Lavasa is a popular picnic destination for families and groups. Hiring a 13 seater Tempo Traveller ensures everyone travels together, carries picnic supplies comfortably, and enjoys a stress-free day trip without parking or navigation worries."
    },
    {
      "title": "Corporate Team Trips to Lavasa",
      "description": "Corporate teams often choose Lavasa for offsite meetings and team-building activities. A Tempo Traveller provides punctual, organized, and professional group transportation, allowing teams to focus on bonding and planning instead of travel logistics."
    },
    {
      "title": "Weekend Getaways from Pune",
      "description": "Lavasa is ideal for short weekend escapes. A 13 seater Tempo Traveller allows groups to depart together, maximize sightseeing time, and return safely without driving fatigue, making the getaway more enjoyable."
    },
    {
      "title": "Lavasa Sightseeing Spots",
      "description": "Traveling in a Tempo Traveller makes it easy to explore viewpoints, lakeside areas, and nearby attractions around Lavasa without worrying about vehicle coordination or road unfamiliarity."
    },
    {
      "title": "Monsoon Trips to Lavasa",
      "description": "Lavasa becomes especially scenic during monsoon, but ghat roads require careful driving. Experienced drivers and stable Tempo Travellers ensure safe and comfortable monsoon travel for your group."
    },
    {
      "title": "Wedding & Event Guest Travel",
      "description": "Lavasa is occasionally chosen for destination weddings and private events. A 13 seater Tempo Traveller is ideal for transporting wedding guests and family members comfortably and on schedule."
    },
    {
      "title": "Local Sightseeing & Photography Tours",
      "description": "Photography groups and leisure travelers often visit Lavasa for scenic views. Group travel in a Tempo Traveller allows flexible stops and relaxed exploration."
    },
    {
      "title": "Stress-Free Group Coordination",
      "description": "Traveling together in one Tempo Traveller eliminates confusion, delays, and communication issues, ensuring a smooth and enjoyable group trip to Lavasa."
    }
  ],

  "services": [
    {
      "name": "13 Seater Tempo Traveller for Lavasa Tour",
      "description": "Sanavi Travels provides dedicated 13 seater Tempo Traveller services for Lavasa tours, ensuring safe, comfortable, and well-coordinated group travel. Our service is ideal for families, friends, corporate teams, and leisure travelers planning a relaxed trip to Lavasa."
    },
    {
      "name": "AC 13 Seater Tempo Traveller Lavasa",
      "description": "AC Tempo Travellers offer a cool and comfortable travel environment, making them perfect for summer trips and long sightseeing hours in and around Lavasa."
    },
    {
      "name": "Non AC 13 Seater Tempo Traveller Lavasa",
      "description": "Non AC Tempo Travellers provide an economical option for budget-conscious groups while maintaining safety, seating comfort, and reliability."
    },
    {
      "name": "Luxury 13 Seater Tempo Traveller Lavasa",
      "description": "Luxury Tempo Travellers feature premium interiors, pushback seats, and smooth suspension, ideal for corporate trips, premium family travel, and special occasions."
    },
    {
      "name": "Tempo Traveller Hire for Family Lavasa",
      "description": "Family-friendly Tempo Travellers ensure safe, spacious, and relaxed travel for all age groups, including children and senior citizens."
    },
    {
      "name": "Tempo Traveller for Corporate Lavasa",
      "description": "Corporate Tempo Traveller services support organized transportation for offsite meetings, team outings, and corporate leisure trips to Lavasa."
    },
    {
      "name": "Tempo Traveller for Group Lavasa",
      "description": "Group travel services ensure everyone travels together comfortably, improving coordination and overall trip enjoyment."
    },
    {
      "name": "Affordable 13 Seater Tempo Traveller Lavasa",
      "description": "Sanavi Travels offers budget-friendly rental packages without compromising on vehicle quality, safety, or driver professionalism."
    },
    {
      "name": "Tempo Traveller with Driver Lavasa",
      "description": "All rentals include experienced drivers familiar with Pune–Lavasa routes, ghat roads, and tourist areas, ensuring safe and timely travel."
    },
    {
      "name": "Tempo Traveller for Picnic & Sightseeing Lavasa",
      "description": "Tempo Travellers are ideal for picnic trips and sightseeing tours, offering flexibility, comfort, and sufficient space for belongings."
    }
  ],

  "tableData": [
    ["13 Seater Tempo Traveller", "AC Tempo Traveller"],
    ["Non AC Tempo Traveller", "Luxury Tempo Traveller"],
    ["Family Travel", "Corporate Travel"],
    ["Picnic Trip", "Weekend Getaway"],
    ["Outstation Travel", "Lavasa Sightseeing"]
  ],

  "whychoose": [
    { "WhyChooseheading": "Experienced Lavasa Route Drivers", "WhyChoosedescription": "Drivers skilled in ghat roads and Lavasa travel routes." },
    { "WhyChooseheading": "Comfortable Group Seating", "WhyChoosedescription": "Spacious seating with ample legroom for long rides." },
    { "WhyChooseheading": "Well-Maintained Vehicles", "WhyChoosedescription": "Regular servicing and cleanliness ensured." },
    { "WhyChooseheading": "Flexible Travel Plans", "WhyChoosedescription": "Customizable one-day or multi-day packages." },
    { "WhyChooseheading": "Safe & Reliable Travel", "WhyChoosedescription": "Focus on passenger safety and smooth driving." },
    { "WhyChooseheading": "Transparent Pricing", "WhyChoosedescription": "Clear pricing with no hidden charges." },
    { "WhyChooseheading": "Group-Friendly Travel", "WhyChoosedescription": "Entire group travels together comfortably." },
    { "WhyChooseheading": "Trusted Travel Partner", "WhyChoosedescription": "Sanavi Travels is known for dependable service." }
  ]
};

const faqData = [
  { question: 'Do you provide 13 seater Tempo Traveller for Lavasa tour?', answer: 'Yes, Sanavi Travels offers 13 seater Tempo Traveller services for Lavasa tours.' },
  { question: 'Are AC Tempo Travellers available for Lavasa?', answer: 'Yes, AC and Non AC options are available.' },
  { question: 'Is the service suitable for family trips?', answer: 'Yes, it is ideal for families and groups.' },
  { question: 'Are drivers experienced with Lavasa ghat roads?', answer: 'Yes, our drivers are trained and familiar with the route.' },
  { question: 'Can we plan a one-day Lavasa trip?', answer: 'Yes, one-day and multi-day packages are available.' },
  { question: 'Is advance booking recommended?', answer: 'Yes, advance booking is advised for weekends and holidays.' },
  { question: 'Are Tempo Travellers cleaned before trips?', answer: 'Yes, all vehicles are cleaned and sanitized before departure.' },
  { question: 'Can Tempo Traveller be used for corporate outings?', answer: 'Yes, it is commonly used for corporate team trips.' },
  { question: 'Is the pricing affordable for group travel?', answer: 'Yes, we offer competitive and transparent pricing.' },
  { question: 'Do you provide pickup from Pune?', answer: 'Yes, pickup is available from Pune and nearby areas.' }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohan Deshmukh',
    feedback: 'Our Lavasa trip in a 13 seater Tempo Traveller was very comfortable. Smooth ride and professional driver.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Sneha Patil',
    feedback: 'Sanavi Travels managed our family Lavasa picnic perfectly. Clean vehicle and great service.',
    rating: 5
  }
];

















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];






const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "13 Seater Tempo Traveller for Lavasa Tour - Sanavi Travels",
  "description": "Sanavi Travels offers 13-seater Tempo Travellers for Lavasa tours, including family trips, corporate travel, group tours, weddings, picnics, local sightseeing, and outstation trips. AC and Non-AC options are available with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};








  return (
    <div>

<Helmet>
  <title>
    Call : +91 7387507373 | 13 Seater Tempo Traveller for Lavasa Tour | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book 13-seater Tempo Travellers for Lavasa tours with Sanavi Travels. AC & Non-AC Tempo Travellers for family trips, corporate travel, group tours, weddings, picnics, local sightseeing, and outstation trips with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/281.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Onethreeseatertempolavasa;